import { Calendar } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface UrgencyBadgeProps {
  variant?: "slots" | "visitors" | "demand";
  className?: string;
}

// Policy-safe availability badge. No fake scarcity, no simulated
// visitor counts, no urgency claims. Kept for backward compatibility
// with existing call sites but always renders the same neutral copy.
export const UrgencyBadge = ({ className = "" }: UrgencyBadgeProps) => {
  const { language } = useLanguage();

  const texts: Record<string, string> = {
    tr: "Bu hafta danışma randevusu imkânı",
    en: "Consultation availability this week",
    fr: "Consultations disponibles cette semaine",
    nl: "Consultaties beschikbaar deze week",
    ar: "مواعيد استشارة متاحة هذا الأسبوع",
  };

  const text = texts[language] || texts.en;

  return (
    <div
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-white text-sm font-medium backdrop-blur-sm bg-primary/80 ${className}`}
    >
      <Calendar className="w-4 h-4" />
      <span>{text}</span>
    </div>
  );
};
